import React from "react";
import styles from "../components/laymanComp_css/LaymanPage9.module.css";
import { Link } from "@mui/material";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/protogonos.json";

export default function LaymanPage9_protogonos_part() {
  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  );
}
